module.exports = __webpack_public_path__ + "img/mer.befd51c.svg";